export default __webpack_public_path__ + "static/media/permissions.3ff09318.svg";